import { render, staticRenderFns } from "./Winner.vue?vue&type=template&id=4cb318b4&scoped=true"
import script from "./Winner.vue?vue&type=script&lang=js"
export * from "./Winner.vue?vue&type=script&lang=js"
import style0 from "./Winner.vue?vue&type=style&index=0&id=4cb318b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb318b4",
  null
  
)

export default component.exports